import { render, staticRenderFns } from "./ModalFullScreenNew.vue?vue&type=template&id=457fdfea&scoped=true"
import script from "./ModalFullScreenNew.vue?vue&type=script&lang=ts"
export * from "./ModalFullScreenNew.vue?vue&type=script&lang=ts"
import style0 from "./ModalFullScreenNew.vue?vue&type=style&index=0&id=457fdfea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fdfea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457fdfea')) {
      api.createRecord('457fdfea', component.options)
    } else {
      api.reload('457fdfea', component.options)
    }
    module.hot.accept("./ModalFullScreenNew.vue?vue&type=template&id=457fdfea&scoped=true", function () {
      api.rerender('457fdfea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ModalFullScreenNew.vue"
export default component.exports